import { render, staticRenderFns } from "./Navbar_Moblie.vue?vue&type=template&id=b0572b52&scoped=true"
import script from "./Navbar_Moblie.vue?vue&type=script&lang=js"
export * from "./Navbar_Moblie.vue?vue&type=script&lang=js"
import style0 from "./Navbar_Moblie.vue?vue&type=style&index=0&id=b0572b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0572b52",
  null
  
)

export default component.exports